import _classCallCheck from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/housing-submarkets/housing-submarkets/node_modules/@babel/runtime/helpers/esm/createClass";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as log from '../log';
import { isConcatSpec, isHConcatSpec, isVConcatSpec } from './concat';
import { isFacetSpec } from './facet';
import { isLayerSpec } from './layer';
import { isRepeatSpec } from './repeat';
import { isUnitSpec } from './unit';
export var SpecMapper = /*#__PURE__*/function () {
  function SpecMapper() {
    _classCallCheck(this, SpecMapper);
  }

  _createClass(SpecMapper, [{
    key: "map",
    value: function map(spec, params) {
      if (isFacetSpec(spec)) {
        return this.mapFacet(spec, params);
      } else if (isRepeatSpec(spec)) {
        return this.mapRepeat(spec, params);
      } else if (isHConcatSpec(spec)) {
        return this.mapHConcat(spec, params);
      } else if (isVConcatSpec(spec)) {
        return this.mapVConcat(spec, params);
      } else if (isConcatSpec(spec)) {
        return this.mapConcat(spec, params);
      } else {
        return this.mapLayerOrUnit(spec, params);
      }
    }
  }, {
    key: "mapLayerOrUnit",
    value: function mapLayerOrUnit(spec, params) {
      if (isLayerSpec(spec)) {
        return this.mapLayer(spec, params);
      } else if (isUnitSpec(spec)) {
        return this.mapUnit(spec, params);
      }

      throw new Error(log.message.invalidSpec(spec));
    }
  }, {
    key: "mapLayer",
    value: function mapLayer(spec, params) {
      var _this = this;

      return Object.assign(Object.assign({}, spec), {
        layer: spec.layer.map(function (subspec) {
          return _this.mapLayerOrUnit(subspec, params);
        })
      });
    }
  }, {
    key: "mapHConcat",
    value: function mapHConcat(spec, params) {
      var _this2 = this;

      return Object.assign(Object.assign({}, spec), {
        hconcat: spec.hconcat.map(function (subspec) {
          return _this2.map(subspec, params);
        })
      });
    }
  }, {
    key: "mapVConcat",
    value: function mapVConcat(spec, params) {
      var _this3 = this;

      return Object.assign(Object.assign({}, spec), {
        vconcat: spec.vconcat.map(function (subspec) {
          return _this3.map(subspec, params);
        })
      });
    }
  }, {
    key: "mapConcat",
    value: function mapConcat(spec, params) {
      var _this4 = this;

      var concat = spec.concat,
          rest = __rest(spec, ["concat"]);

      return Object.assign(Object.assign({}, rest), {
        concat: concat.map(function (subspec) {
          return _this4.map(subspec, params);
        })
      });
    }
  }, {
    key: "mapFacet",
    value: function mapFacet(spec, params) {
      return Object.assign(Object.assign({}, spec), {
        // TODO: remove "any" once we support all facet listed in https://github.com/vega/vega-lite/issues/2760
        spec: this.map(spec.spec, params)
      });
    }
  }, {
    key: "mapRepeat",
    value: function mapRepeat(spec, params) {
      return Object.assign(Object.assign({}, spec), {
        // as any is required here since TS cannot infer that the output type satisfies the input type
        spec: this.map(spec.spec, params)
      });
    }
  }]);

  return SpecMapper;
}();